<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="txt-head black--text mb-2">
        <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
      </div>
      <div class="txt-head black--text mb-2">1. แผนงานการทำงานวิจัยและพัฒนา งานออกแบบ และงานวิศวกรรมภายในอาคารอำนวยการ</div>
      <div class="d-flex justify-end">
        <Button
          :disabled="editMode"
          @onClick="addPlan"
          theme="500"
          prepend-icon="mdi-plus"
          >แผนการดำเนินงาน</Button
        >
      </div>
      <div class="d-flex justify-space-between card-part">
        <div
          v-for="(item, i) in tableHeader"
          :key="i"
          :style="{ width: item.width }"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="card-part">
        <div
          v-if="form.spider_chart_3 && form.spider_chart_3.length > 0"
          class="d-flex flex-column gap-12"
        >
          <div
            v-for="(item, i) in form.spider_chart_3"
            :key="i"
            class="d-flex mb-3"
          >
            <div
              class="d-flex align-center"
              style="min-width: 10%; max-width: 10%"
            >
              <v-btn small icon @click="editPlan(i)">
                <Iconify
                  icon="material-symbols:edit"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
              <v-btn small icon @click="deletePlan(i)">
                <Iconify
                  icon="material-symbols:delete"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
            </div>
            <div class="flex" style="min-width: 10%; max-width: 10%">
              {{ item.year }}
            </div>
            <div class="flex text-break" style="min-width: 15%; max-width: 15%">
              {{ item.name }}
            </div>
            <div class="flex text-break" style="min-width: 25%; max-width: 25%">
              {{ item.plan }}
            </div>
            <div class="flex text-break" style="min-width: 15%; max-width: 15%">
              {{
                Number(item.budget || 0).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) + " บาท"
              }}
            </div>
            <div class="flex" style="min-width: 15%; max-width: 15%">
              <!-- {{ toDateFormat2(item.duration_from) }} ถึง {{ toDateFormat2(item.duration_to) }} -->
                {{ item.duration }}
            </div>
            <div class="flex" style="min-width: 10%; max-width: 10%">
              {{ 
                (Array.isArray(item?.source_topical) ? item.source_topical.join(", ") : "") + 
                (item?.source_topical_other ? (" (" + item.source_topical_other + ")") : "") 
              }}           
            </div>
          </div>
        </div>
        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
      <div v-if="editMode" class="pt-6">
        <div>
          <div class="d-flex gap-16">
            <div class="flex" style="min-width: 35.7%; max-width: 35.7%">
              <div class="mb-1 black--text">ปีที่</div>
              <TextField
                theme="3"
                input-type="number"
                :value="planNew.year"
                @onChange="planNew.year = $event"
              >
              </TextField>
            </div>
            <div style="visibility: hidden">บาท</div>
            <div class="flex" style="min-width: 35.7%; max-width: 35.7%">
              <div class="mb-1 black--text">ชื่อโครงการ</div>
              <TextField
                theme="3"
                :value="planNew.name"
                @onChange="planNew.name = $event"
              >
              </TextField>
            </div>
          </div>
          <div>
            <div class="mb-1 black--text">แผนการดำเนินงาน</div>
            <TextArea
              theme="3"
              height="120"
              :value="planNew.plan"
              @onChange="planNew.plan = $event"
            >
            </TextArea>
          </div>
          <div class="d-flex gap-16">
            <div class="flex">
              <div class="mb-1 black--text">งบประมาณ</div>
              <TextField
                theme="3"
                input-type="number"
                :value="planNew.budget"
                @onChange="planNew.budget = $event"
              >
              </TextField>
            </div>
            <div class="d-flex align-center">บาท</div>
            <div class="d-flex gap-16">
              <div>
                <div class="mb-1 black--text">ระยะเวลา ดำเนินการ</div>
                 <TextField
                  theme="3"
                  :value="planNew.duration"
                  @onChange="planNew.duration = $event"
                >
              </TextField>
                <!-- <DatePicker
                  theme="3"
                  :value="planNew.duration_from"
                  :min-date="todayDate"
                  @onInput="
                    planNew.duration_from = $event;
                    $forceUpdate();
                  "
                >
                </DatePicker> -->
              </div>
            </div>
            <div class="flex"></div>
          </div>
          <div>
            <div class="mb-1 black--text">แหล่งทุน</div>
            <v-row style="min-height: 90px;">
              <v-col cols="3" v-for="(item, i) in masterData?.source_topical" :key="i" class="d-flex gap-16">
                <CheckBox
                  style="max-width: unset"
                  :input-value="planNew.source_topical?.includes(item.name)"
                  @onChange="updateSourceTopical(item.name, $event)"
                >
                  {{item.name}}
                </CheckBox>
                <TextField
                  v-if="planNew.source_topical?.includes('อื่นๆ') && item.name ==='อื่นๆ'"
                  :disabled="!planNew.source_topical?.includes('อื่นๆ')"
                  theme="3"
                  :value="planNew.source_topical_other"
                  @onChange="planNew.source_topical_other = $event"
                >
                </TextField>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="
              editMode = false;
              planNew = {};
            "
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        2. แผนอัตรากำลังคนที่ปฏิบัติงานเฉพาะในอาคารอำนวยการอุทยานวิทยาศาสตร์
      </div>
      <div class="d-flex justify-end">
        <Button
          :disabled="editMode2"
          @onClick="addManPower"
          theme="500"
          prepend-icon="mdi-plus"
          >แผนอัตรากำลังคน</Button
        >
      </div>
      <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
        <div class="d-flex justify-space-between gap-8 px-3 mb-3">
          <div class="flex" style="min-width: 10%; max-width: 10%">
            {{ "จัดการ" }}
          </div>
          <div class="flex" style="min-width: 18%; max-width: 18%; flex: 1">
            <div>ระดับวุฒิการศึกษา</div>
            <div>(Education Level)</div>
          </div>
          <div class="flex" style="min-width: 18%; max-width: 18%; flex: 1">
            <div>ปีที่ 1</div>
            <div>(เริ่มสัญญา)</div>
          </div>
          <div class="flex" style="min-width: 18%; max-width: 18%; flex: 1">
            <div>ปีที่ 2</div>
            <div>(จำนวนที่เพิ่มขึ้นในปี)</div>
          </div>
          <div class="flex" style="min-width: 18%; max-width: 18%; flex: 1">
            <div>ปีที่ 3</div>
            <div>(จำนวนที่เพิ่มขึ้นในปี)</div>
          </div>
          <div class="flex" style="min-width: 18%; max-width: 18%; flex: 1">
            รวมพนักงานทั้งหมด
          </div>
        </div>
        <div
          v-if="form.area_form_3_2 && form.area_form_3_2.length > 0"
          class="d-flex flex-column gap-12"
        >
          <divcard
            v-for="(item, i) in form.area_form_3_2"
            :key="i"
            class="plan-card d-flex justify-space-between gap-8"
          >
            <div
              class="d-flex align-center"
              style="min-width: 10%; max-width: 10%"
            >
              <v-btn small icon @click="editManPower(i)">
                <Iconify
                  icon="material-symbols:edit"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
              <v-btn small icon @click="deleteManPower(i)">
                <Iconify
                  icon="material-symbols:delete"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
            </div>
            <div
              class="align-center"
              style="min-width: 18%; max-width: 18%"
            >
            <div> {{ item.education_level
              }}</div>
             <div v-if="item.description">{{
                " (" + item.description + ")"
              }}</div>
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ item.year_1 }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ item.year_2 }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ item.year_3 }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ Number(item?.total_employee || 0).toLocaleString("en-US") }}
            </div>
          </divcard>
          <divcard class="d-flex justify-space-between gap-8">
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 10%; max-width: 10%"
            ></div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ "อัตรากำลังรวม (Total Number of Staff)" }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ year_1_sum }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ year_2_sum }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ year_3_sum }}
            </div>
            <div
              class="d-flex justify-space-between align-center"
              style="min-width: 18%; max-width: 18%"
            >
              {{ total_sum }}
            </div>
          </divcard>
        </div>
        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
      <div v-if="editMode2" class="card-part">
        <div>
          <div class="mb-1 black--text">
            ระดับวุฒิการศึกษา (Education Level)
          </div>
          <AutoBox
            theme="3"
            :items="education"
            item-text="name"
            item-value="name"
            :value="manPowerNew.education_level"
            @onChange="setManPowerNewField('education_level', $event)"
          ></AutoBox>
        </div>
        <div v-if="manPowerNew.education_level == 'อื่นๆ (Other)'">
          <div class="mb-1 black--text">อธิบาย</div>
          <TextField
            theme="3"
            :value="manPowerNew.description"
            @onChange="setManPowerNewField('description', $event)"
          >
          </TextField>
        </div>
        <div class="mb-1 black--text">แผนอัตรากำลังคน</div>
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">ปีที่ 1</div>
            <TextField
              theme="3"
              input-type="number"
              :value="manPowerNew.year_1"
              @onChange="updateYear('year_1', $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">ปีที่ 2</div>
            <TextField
              theme="3"
              input-type="number"
              :value="manPowerNew.year_2"
              @onChange="updateYear('year_2', $event)"
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">ปีที่ 3</div>
            <TextField
              theme="3"
              input-type="number"
              :value="manPowerNew.year_3"
              @onChange="updateYear('year_3', $event)"
            >
            </TextField>
          </div>
        </div>
        <div>
          <div class="mb-1 black--text">รวมพนักงานทั้งหมด</div>
          <TextField
            :disabled="true"
            theme="3"
            input-type="number"
            :value="manPowerNew.total_employee"
            @onChange="manPowerNew.total_employee = $event"
          >
          </TextField>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="editMode2 = false; manPowerNew = {};"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveManPower"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        3. ประมาณการวันที่ต้องการใช้พื้นที่ (หากได้รับอนุมัติ) (Contract start
        date (if approved))
      </div>
      <div>
        <div class="mb-1 black--text">วัน เดือน ปี</div>
        <DatePicker
          :value="form.estimated_date"
          @onInput="
            form.estimated_date = $event;
            $forceUpdate();
          "
        ></DatePicker>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        4. เอกสารแนบ / ภาคผนวก Annex / Appendix
      </div>
      <div class="mx-3">
        <div>
          1. สำเนาเอกสารสำคัญประกอบการสมัคร (The application shall be
          accompanied with the following documents)
          (กรุณาประทับตราบริษัทและลงนาม รับรองโดยผู้มีอำนาจของบริษัท Please sign
          by company authorized person and stamp the company seal)
          <div class="mx-2">
            <div>
              1.1 หนังสือรับรองบริษัทที่มีอายุไม่เกิน 30 วัน Certificate of
              company registration, not more than 30 days issues
            </div>
            <div>1.2 ภพ. 20 (Vat certificate (Phor por 20))</div>
            <div>1.3 หนังสือบริคณห์สนธิ (Memorandum of Association)</div>
            <div>
              1.4 งบการปีล่าสุดย้อนหลัง 2 ปี (Financial Statement for recent
              calendar year with Cerified Public Accountant CPA’s approval)
            </div>
            <div>
              1.5 กรณีเป็นบริษัทตั้งใหม่ กรุณาแสดงหลักฐานทางการเงินของบริษัท (In
              case of newly established company, please attach a copy of company
              Bank Statement)
            </div>
            <div>
              1.6 เอกสารรายละเอียดเพิ่มเติม (ถ้ามี) Other related documents (If
              applicable)
            </div>
          </div>
          <div class="mt-5">
            2.
            ข้อมูลประกอบเพื่อการคัดเลือกและประเมินผู้ใช้พื้นที่อาคารอำนวยการอุทยานวิทยาศาสตร์
            (Information for evalution process (2 main
            criteria's will be considered during this step, (1) space usage
            activities, (2) Financial data))
            <div class="mx-2">
              <CheckBox
                style="max-width: unset"
                :input-value="form.appendix_info"
                @onChange="form.appendix_info = $event"
                >2.1 กรุณาเสนอวันที่นัดหมายสำหรับบริษัท / หน่วยงาน
                เข้านำเสนอข้อมูลต่อผู้เชี่ยวชาญ</CheckBox
              >
            </div>
          </div>
          <div class="mt-5">
            3. สำเนาเอกสารประกอบการทำสัญญาการให้บริการอุทยานวิทยาศาสตร์
            (Documentation for contract)
            (กรุณาประทับตราบริษัทและ ลงนามรับรองโดยผู้มีอำนาจของบริษัท Please
            sign by company authorized person and stamp the company seal)
            <div class="mx-2">
              <CheckBox
                style="max-width: unset"
                :input-value="form.appendix_doc_cert"
                @onChange="form.appendix_doc_cert = $event"
                >3.1 หนังสือรับรองบริษัทที่มีอายุไม่เกิน 30 วัน Certificate of
                company registration, not more than 30 days issued</CheckBox
              >
              <CheckBox
                style="max-width: unset"
                :input-value="form.appendix_doc_id_card_company"
                @onChange="form.appendix_doc_id_card_company = $event"
                >3.2
                สำเนาบัตรประชาชนผู้มีอำนาจลงนามจำนวนตามที่ระบุไว้ในหนังสือรับรอง
                Copy of ID card/passport of authorizedperson(s) as specified in
                company certificate.</CheckBox
              >
              <CheckBox
                style="max-width: unset"
                :input-value="form.appendix_doc_witness"
                @onChange="form.appendix_doc_witness = $event"
                >3.3 สำเนาบัตรประชาชนพยานฝ่ายบริษัท จำนวน 1 คน (Copy of ID
                card/passport (one person) for the witness)</CheckBox
              >
              <CheckBox
                style="max-width: unset"
                :input-value="form.appendix_doc_postal"
                @onChange="form.appendix_doc_postal = $event"
                >3.4 ชื่อผู้รับ
                และที่อยู่สำหรับการจัดส่งสัญญาผ่านทางไปรษณีย์ลงทะเบียนให้บริษัท
                (The receipt's name and address for the contract receiving via
                registered mail) (กรุณาแนบนามบัตร (ถ้ามี) Please attach a
                business card (if applicable))
              </CheckBox>
              <div v-if="form.appendix_doc_postal">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">ชื่อ - สกุล (Name)</div>
                    <TextField
                      theme="3"
                      :value="form.postal_name"
                      @onChange="setFormField('postal_name', $event)"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">ตำแหน่ง (Position)</div>
                    <TextField
                      theme="3"
                      :value="form.postal_position"
                      @onChange="setFormField('postal_position', $event)"
                    >
                    </TextField>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">โทรศัพท์ (Telephone No.)</div>
                    <TextField
                      placeholder="02XXXXXXX"
                      theme="3"
                      input-type="number"
                      :value="form.postal_phone"
                      @onChange="setFormField('postal_phone', $event)"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">มือถือ (Mobile Phone)</div>
                    <TextField
                      placeholder="09XXXXXXXX"
                      theme="3"
                      input-type="number"
                      :rules="mobilePhoneRules"
                      :value="form.postal_mobile_phone"
                      @onChange="setFormField('postal_mobile_phone', $event)"
                    >
                    </TextField>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">โทรสาร (Facsimile No.)</div>
                    <TextField
                      input-type="number"
                      theme="3"
                      :value="form.postal_fac"
                      @onChange="setFormField('postal_fac', $event)"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">อีเมล (Email)</div>
                    <TextField
                      theme="3"
                      :rules="emailRules"
                      :value="form.postal_email"
                      @onChange="setFormField('postal_email', $event)"
                    >
                    </TextField>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">ที่อยู่ (Address)</div>
                    <TextField
                      theme="3"
                      :value="form.postal_address"
                      @onChange="setFormField('postal_address', $event)"
                    >
                    </TextField>
                  </div>
                </div>
              </div>
              <CheckBox
                style="max-width: unset"
                :input-value="form.appendix_doc_contact"
                @onChange="form.appendix_doc_contact = $event"
                >3.5 ข้อมูลรายชื่อสำหรับการติดต่อในระหว่างการใช้บริการพื้นที่
                (Contact person for : (กรุณาแนบนามบัตร (ถ้ามี) Please attach a
                business card (if applicable)))
              </CheckBox>
              <div v-if="form.appendix_doc_contact">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">ชื่อ - สกุล (Name)</div>
                    <TextField
                      theme="3"
                      :value="form.contact_name"
                      @onChange="setFormField('contact_name', $event)"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">ตำแหน่ง (Position)</div>
                    <TextField
                      theme="3"
                      :value="form.contact_position"
                      @onChange="setFormField('contact_position', $event)"
                    >
                    </TextField>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">โทรศัพท์ (Telephone No.)</div>
                    <TextField
                      placeholder="02XXXXXXX"
                      theme="3"
                      input-type="number"
                      :value="form.contact_phone"
                      @onChange="setFormField('contact_phone', $event)"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">มือถือ (Mobile Phone)</div>
                    <TextField
                      placeholder="09XXXXXXXX"
                      theme="3"
                      input-type="number"
                      :rules="mobilePhoneRules"
                      :value="form.contact_mobile_phone"
                      @onChange="setFormField('contact_mobile_phone', $event)"
                    >
                    </TextField>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">โทรสาร (Facsimile No.)</div>
                    <TextField
                      theme="3"
                      input-type="number"
                      :value="form.contact_fac"
                      @onChange="setFormField('contact_fac', $event)"
                    >
                    </TextField>
                  </div>

                  <div class="flex">
                    <div class="mb-1 black--text">อีเมล (Email)</div>
                    <TextField
                      theme="3"
                      :value="form.contact_email"
                      :rules="emailRules"
                      @onChange="setFormField('contact_email', $event)"
                    >
                    </TextField>
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">ที่อยู่ (Address)</div>
                    <TextField
                      theme="3"
                      :value="form.contact_address"
                      @onChange="setFormField('contact_address', $event)"
                    >
                    </TextField>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextArea from "../../components/input/TextArea";
import TextField from "../../components/input/TextField";
import SwitchInset from "../../components/input/SwitchInset";
import AutoBox from "../../components/input/AutoBox";
import Button from "@/components/input/Button";
import CheckBox from "../../components/input/CheckBox";
import DatePicker from "../../components/input/DatePicker";
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { mapState } from "vuex";
import Divcard from "../../components/Divcard.vue";
export default {
  name: "ThridForm",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button,
    CheckBox,
    DatePicker,
    TextArea,
  },
  props: {
    masterData: Object,
    formData: Object,
  },
  data() {
    return {
      education: [
        { name: "ปริญญาเอก (Ph.D.)" },
        { name: "ปริญญาโท (Master)" },
        { name: "ปริญญาตรี (Bachelor)" },
        { name: "มัธยมศึกษา (High School)" },
        { name: "อื่นๆ (Other)" },
      ],
      form: {
        area_form_3_2: [],
        spider_chart_3: [],
        appendix_info: false,
        appendix_doc_cert: false,
        appendix_doc_id_card_company: false,
        appendix_doc_witness: false,
        appendix_doc_postal: false,
        appendix_doc_contact: false,
      },
      tableHeader: [
        {
          name: "จัดการ",
          width: "10%",
        },
        {
          name: "ปีที่",
          width: "10%",
        },
        {
          name: "ชื่อโครงการ",
          width: "15%",
        },
        {
          name: "แผนการดำเนินงาน",
          width: "25%",
        },
        {
          name: "งบประมาณ",
          width: "15%",
        },
        {
          name: "ระยะเวลา ดำเนินการ",
          width: "15%",
        },
        {
          name: "แหล่งทุน",
          width: "10%",
        },
      ],
      planNew: {},
      editMode: false,
      editMode2: false,

      manPowerNew: {},
      websiteRules: [
        (v) => !!v || "",
        (v) => /^(http|https):\/\/[^ "]+$/.test(v) || "เว็บไซต์ไม่ถูกต้อง",
      ],
      zipCodeRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 5) || "รหัสไปรษณีย์ต้องมี 5 หลัก",
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
      mobilePhoneRules: [
        (v) => !!v || "",
      ],
      pidRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 13) || "เลขประจำตัวประชาชนต้องมี 13 หลัก",
      ],
    };
  },
  computed: {
    ...mapState({}),
    year_1_sum() {
      return this.form.area_form_3_2.reduce(
        (a, b) => parseInt(a) + parseInt(b.year_1),
        0
      );
    },
    year_2_sum() {
      return this.form.area_form_3_2.reduce(
        (a, b) => parseInt(a) + parseInt(b.year_2),
        0
      );
    },
    year_3_sum() {
      return this.form.area_form_3_2.reduce(
        (a, b) => parseInt(a) + parseInt(b.year_3),
        0
      );
    },
    total_sum() {
      return this.form.area_form_3_2.reduce(
        (a, b) => parseInt(a) + parseInt(b.total_employee),
        0
      );
    },
  },
  created() {
    eventBus.$on("thirdForm", () => {
      eventBus.$emit("thirdFormSend", this.form);
    });
    eventBus.$emit("thirdFormSend", this.form);
  },
  watch: {
    manPowerNew:{
      handler(newValue){
        console.log(newValue);
        
      },
      deep: true,
      immediate: true,
    },
    form: {
      handler(newValue) {
        if (!newValue?.appendix_doc_postal) {
          this.form.postal_name = null;
          this.form.postal_position = null;
          this.form.postal_phone = null;
          this.postal_mobile_phone = null;
          this.postal_fac = null;
          this.postal_email = null;
          this.postal_address = null;
        }
        if (!newValue?.appendix_doc_contact) {
          this.form.contact_name = null;
          this.form.contact_position = null;
          this.form.contact_phone = null;
          this.contact_mobile_phone = null;
          this.contact_fac = null;
          this.contact_email = null;
          this.contact_address = null;
        }
      },
      deep: true,
    },
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));
        this.form.spider_chart_3 = this.form.spider_chart_3 || [];
        this.form.area_form_3_2 = this.form.area_form_3_2 || [];
        this.form.appendix_info = this.form.appendix_info || false;
        this.form.appendix_doc_cert = this.form.appendix_doc_cert || false;
        this.form.appendix_doc_id_card_company =
          this.form.appendix_doc_id_card_company || false;
        this.form.appendix_doc_witness =
          this.form.appendix_doc_witness || false;
        this.form.appendix_doc_postal = this.form.appendix_doc_postal || false;
        this.form.appendix_doc_contact =
          this.form.appendix_doc_contact || false;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    updateYear(field, value) {
      // Parse input as a number or default to 0 if invalid
      const parsedValue = parseFloat(value) || 0;
      this.manPowerNew[field] = parsedValue;

      // Recalculate the total
      this.manPowerNew.total_employee =
        (parseFloat(this.manPowerNew.year_1) || 0) +
        (parseFloat(this.manPowerNew.year_2) || 0) +
        (parseFloat(this.manPowerNew.year_3) || 0);
      this.$forceUpdate();
    },
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setManPowerNewField(field, val) {
      if(field == 'education_level' && val == 'อื่นๆ (Other)'){
        this.manPowerNew.description = '';
      }
      this.manPowerNew[field] = val;
      this.$forceUpdate();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    addPlan() {
      this.editMode = true;
      this.planNew = {
        isNew: true,
        source_topical: [],
      };
    },
    savePlan() {
      if (!this.planNew.isNew) {
        this.form.spider_chart_3[this.planNew.temp_index] = this.planNew;
      } else {
        this.form.spider_chart_3?.push(this.planNew);
      }
      this.planNew = {};
      this.editMode = false;
    },
    editPlan(i) {
      this.editMode = false;
      this.planNew = {
        ...this.removeVModel(this.form.spider_chart_3[i]),
        temp_index: i,
        isNew: false,
      };
      this.editMode = true;
      this.$forceUpdate();
    },
    deletePlan(i) {
      this.form.spider_chart_3.splice(i, 1);
      this.$forceUpdate();
    },
    updateSourceTopical(value, checked) {
      if (value === "อื่นๆ") {
        this.planNew.source_topical_other = "";
      }
      const index = this.planNew.source_topical?.indexOf(value);
      if (checked && index === -1) {
        this.planNew.source_topical?.push(value);
      } else if (!checked && index !== -1) {
        this.planNew.source_topical?.splice(index, 1);
      }
    },

    addManPower() {
      this.manPowerNew.isNew = true;
      this.editMode2 = true;
    },
    editManPower(i) {
      this.editMode2 = false;
      this.manPowerNew = {
        ...this.removeVModel(this.form.area_form_3_2[i]),
        temp_index: i,
        isNew: false,
      };
      this.editMode2 = true;
      this.$forceUpdate();
    },
    deleteManPower(i) {
      this.form.area_form_3_2.splice(i, 1);
      this.$forceUpdate();
    },
    saveManPower() {
      if (!this.manPowerNew.isNew) {
        this.form.area_form_3_2[this.manPowerNew.temp_index] = this.manPowerNew;
      } else {
        this.form.area_form_3_2.push(this.manPowerNew);
      }
      this.manPowerNew = {};
      this.editMode2 = false;
    },
  },
};
</script>

<style></style>
